import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Typography, Button } from '@mui/material'
import { chassisPhotoMedia, scannedVinInfo } from './chassis-plate'

// Chassis plate rows of a control detail page (CATP, constructor or member
// control): the plate photo taken on the iPad and the VIN read on it, with a
// warning when it is not the VIN of the chassis the control was recorded on.
export default function ChassisPlateDetails({
  control,
  textClassName,
  onShowMedia,
}) {
  const { t } = useTranslation()
  const chassisPhoto = chassisPhotoMedia(control.chassisPhotoUrl)
  const scannedVinDetails = scannedVinInfo(control)

  return (
    <>
      <Grid item container spacing={2} alignItems="center">
        <Grid item>
          <Typography variant="h6">
            {t('controls-detail.chassis-photo')}
          </Typography>
        </Grid>
        <Grid item>
          {chassisPhoto.length > 0 ? (
            <Button
              color="primary"
              variant="text"
              onClick={() => onShowMedia(chassisPhoto)}
            >
              {t('controls-detail.view-chassis-photo')}
            </Button>
          ) : (
            <Typography variant="h6" className={textClassName}>
              {t('controls-detail.no-chassis-photo')}
            </Typography>
          )}
        </Grid>
      </Grid>
      {scannedVinDetails && (
        <Grid item container spacing={2} alignItems="center">
          <Grid item>
            <Typography variant="h6">
              {t('controls-detail.scanned-vin')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6" className={textClassName}>
              {scannedVinDetails.vin} ({t(scannedVinDetails.sourceKey)})
            </Typography>
          </Grid>
          {scannedVinDetails.mismatch && (
            <Grid item>
              <Typography variant="h6" color="error">
                {t('controls-detail.scanned-vin-mismatch')}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </>
  )
}
